<script setup>
import { ref, getCurrentInstance, reactive } from 'vue'
import Alert from "@/helpers/Alert";
import AuthService from "@/services/AuthService";
import Layout from "@/router/layouts/auth.vue";
import Config from "@/helpers/Config";
import {useRouter} from "vue-router";

const router = useRouter();

// Access the global config which is set in main.js
// It is done like this since "this.$config" is not usable in Composition API. Other option is Composables or state management
const { proxy } = getCurrentInstance()

const msisdn = ref("")
const isReqInProgress = ref(false)
const errorState = reactive({
  isError: false,
  message: ""
})

async function loginWithMobileId() {
  if (!isMsisdnValid()) {
    errorState.isError = true
    errorState.message = "Your MSISDN is invalid."
    return;
  }

  resetError()

  isReqInProgress.value = true
  let baseUrl = proxy.$config.BACKEND_BASE_URL;

  AuthService.authenticateMobileID(msisdn.value, baseUrl)
    .then(async (resp) => {
      if (resp.jwt) {
        await Config.loadConfig(baseUrl)

        if (isEndUser()) {
          await router.push("/pages/self-care");
        } else {
          await router.push("/");
        }

      } else {
        Alert.showError("Login failed", resp["details"])
      }
    })
    .catch((error) => {
      Alert.showErrorMessage(error)
    }).finally(() => {
      isReqInProgress.value = false
    })

}

function isMsisdnValid() {
  return msisdn.value.length > 6;
}

function isEndUser() {
  let roles = AuthService.getSavedRoles();
  return roles.length === 2 && roles.includes("mss_user") && roles.includes("web_enduser");
}

function resetError() {
  errorState.isError = false
  errorState.message = ""
}

</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back!</h5>
                  <p>Sign in to continue to Kiuru Web Manager.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                    src="@/assets/images/profile-img.png"
                    alt
                    class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/methics/pby-logo.png" alt height="35" style="margin-left: 5px;">
                  </span>
                </div>
              </router-link>
            </div>

            <BAlert :model-value="errorState.isError" variant="danger">
              {{errorState.message}}
            </BAlert>

            <b-form class="p-2" @submit.prevent="loginWithMobileId">
              <b-form-group
                  class="mb-3"
                  id="input-group-1"
                  label="MSISDN"
                  label-for="input-1"
              >
                <b-form-input
                    id="msisdn"
                    v-model="msisdn"
                    type="text"
                    placeholder="Enter MSISDN"
                ></b-form-input>
              </b-form-group>

              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block">
                  Log In
                </b-button>
              </div>

            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <div v-if="isReqInProgress" class="text-center">
          <span class="spinner-border text-primary m-2" aria-hidden="true"></span>
        </div>
        <div class="mt-5 text-center">
          <router-link to="/login"><b-button type="button" variant="outline-primary" class="btn">Use Username to Login</b-button></router-link>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>

</style>